import React from "react";
import { InlineError } from "./Notifications/Error";
import { CheckCircle } from "lucide-react";

function Input({
  label,
  name,
  type,
  placeHolder,
  register,
  errors,
  readOnly = false,
  disabled = false,
  verified = false,
  className = "",
}) {
  return (
    <div className="text-sm">
      <label className="font-normal text-sm">{label}</label>

      <div className="relative mt-2">
        <input
          type={type}
          name={name}
          {...register}
          placeholder={placeHolder}
          readOnly={readOnly}
          disabled={disabled}
          className={`w-full p-4 border border-gray-200 rounded text-gray-500 bg-white focus:border-gray-300 ${
            readOnly ? "bg-gray-100 cursor-not-allowed pr-12" : ""
          } ${className}`}
        />

        {verified && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-1 px-2 py-1 rounded-full bg-blue-200 text-navy text-xs font-medium">
            <CheckCircle className="w-3.5 h-3.5" />
            Verified
          </span>
        )}
      </div>

      {errors && <InlineError text={errors?.message} />}
    </div>
  );
}

export default Input;
